import cn from 'classnames';
import { useEffect } from 'react';

import { Modal } from '@webapp/common/components/modal';

import css from './notification-modal.css';

interface Props {
    title?: string;
    place?: 'top' | 'bottom';
    titleColor?: string;
    onClose: () => void;
    autoClose?: boolean;
    autoCloseTimer?: number;
    children?: ReactNode;
}

export const NotificationModal: FC<Props> = ({
    // place,
    children,
    onClose,
    autoClose = true,
    autoCloseTimer = 3000,
}) => {
    useEffect(() => {
        let timer;

        if (autoClose) {
            timer = setTimeout(() => {
                onClose?.();
            }, autoCloseTimer);
        }

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <Modal
            visible={true}
            style={{ maxWidth: '580px' }}
            className={cn(css.modal, css.notificationModal)}
            onClose={onClose}
            overlayClassName={css.overlayClassName}
            closeBtn={false}
            disableOutsideClick={true}
        >
            {children}
        </Modal>
    );
};
